import React from 'react';
import { i18n } from 'config/locales';

import {
  CommonOnUpdate, CommonOnError, CommonScrollIntoView, CommonRequired,
  CommonAddressBooks
} from 'types/props';
import ValidationElement, {
  ValidationElementProps,
} from 'components/Form/ValidationElement/ValidationElement';
import classnames from 'classnames';
import {
  BranchCollectionModel,
  LocationItemModel,
} from 'forms/shared/types';
import BranchCollection from 'components/Form/BranchCollection';
import LocationCollectionItem from './LocationCollectionItem';

/*
 This component was designed to be functionally similar to AdditionalActivity,
 See that component if this one appears broke to determine what action to take.
*/

type LocationCollectionType = BranchCollectionModel<LocationItemModel>;

interface Props extends ValidationElementProps, Partial<LocationCollectionType> {
  onUpdate?: CommonOnUpdate
  onError?: CommonOnError
  className?: string
  scrollIntoView?: CommonScrollIntoView
  required?: CommonRequired
  attribute?: string
  appendFieldTitle?: string
  branchFieldTitle?: string
  formType?: string
    allowNotApplicable?: boolean,
    addressBook?: string,
    addressBooks?: CommonAddressBooks,
    cityLabel?: string,
    countryLabel?: string,
    countyLabel?: string,
    domesticTitle?: string,
    excludeUnitedStates?: boolean,
    foreignTitle?: string,
    includeMilitaryStates?: boolean,
    label?: string,
  locationlabel?:string
    name?: string,
    showDisabledText?: boolean,
    showInternationalStreet?: boolean,
    showMilitaryInstallation?: boolean,
    showPostOffice?: boolean,
    stateLabel?: string,
    street2Label?: string,
    streetLabel?: string,
    useChangeWarning?: boolean,
    zipcodeLabel?: string,
  dispatch?:()=>{},
  geocode:boolean,
  isPoBoxAllowed: boolean,

}

export default class LocationCollection extends ValidationElement<Props> {
  updateBranch = (values: Partial<LocationCollectionType>) => {
    // TODO: FOr MVP I'm letting the extra question exist for Do you have telephone?
    // if this is impermissable then we will need to add logic here to ensure the
    // branch always has one item. I do exepect this will be done before full release.
    this.props.onUpdate({
      ...values,
    });
  };

  render() {
    return (
      <div className={classnames('telephone-list', this.props.className)}>
        <BranchCollection
          label={this.props.branchFieldTitle}
          labelSize="h4"
          appendLabel={this.props.appendFieldTitle}
          appendSize="h4"
          {...(this.props || {})}
          onUpdate={this.updateBranch}
          onError={this.props.onError}
          scrollIntoView={this.props.scrollIntoView}
        >
          <LocationCollectionItem
            addressBook={this.props.addressBook}
            addressBooks={this.props.addressBooks}
            attribute={this.props.attribute}
            bind
            cityLabel={this.props.cityLabel}
            countryLabel={this.props.countryLabel}
            countyLabel={this.props.countyLabel}
            dispatch={this.props.dispatch}
            domesticTitle={this.props.domesticTitle}
            excludeUnitedStates={this.props.excludeUnitedStates}
            foreignTitle={this.props.foreignTitle}
            formType={this.props.formType}
            geocode={this.props.geocode}
            includeMilitaryStates={this.props.includeMilitaryStates}
            isPoBoxAllowed={this.props.isPoBoxAllowed}
            label={this.props.locationlabel}
            name="Item"
            onError={this.props.onError}
            required={this.props.required}
            showDisabledText={this.props.showDisabledText}
            showInternationalStreet={this.props.showInternationalStreet}
            showMilitaryInstallation={this.props.showMilitaryInstallation}
            showPostOffice={this.props.showPostOffice}
            stateLabel={this.props.stateLabel}
            street2Label={this.props.street2Label}
            streetLabel={this.props.streetLabel}
            useChangeWarning={this.props.useChangeWarning}
            zipcodeLabel={this.props.zipcodeLabel}
            showApoFpoDpoPostcodeWhenForeign={this.props.showApoFpoDpoPostcodeWhenForeign}
            hideInstallationNameUnknownWhenForeign={this.props.hideInstallationNameUnknownWhenForeign}
          />
        </BranchCollection>
      </div>
    );
  }
}

LocationCollection.defaultProps = {
  onUpdate: (queue) => {},
  onError: (value, arr) => arr,
  telephoneFieldTitle: 'What is the address?',
  appendFieldTitle: 'Do you have another address to add?',
  branchFieldTitle: 'Do you have an address to add?',
  allowNotApplicable: false,
  showApoFpoDpoPostcodeWhenForeign: false,
};
